import React from 'react';
import Modal from 'components/UI/Modal';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';

class ModalBody extends React.Component {

  constructor(props){
    super(props)
  }

	render() {
		let {
      show,
      proceed,
      dismiss,
      cancel,
    } = this.props;

		return (
			<Modal
				className='start-free-trial-modal'
				hasHeader={true}
        // hasFooter={true}

				headerTitle={__("Create Your School", "planDetails")}
				headerIcon="fa icon-bank"
        fixedWidth={743}
        contentHeight={490}
        onCloseModalClick={dismiss}

        footerType="grey"
        isShowingModal={show} >
        <ModalContent 
          onFormChange={()=>proceed()}
         />
			</Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/StartFreeTrial/ModalBody.js